// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"69a3b3cc","173":"d47b8d50","275":"adaf6c39","447":"c3d47487","520":"196efb99"}[chunkId] + ".chunk.js";
};